<hr>

<div class="app-footer">
    <p>App Mercaderies - V{{Settings.version}}</p>
</div>
